import React from "react";
import { Box, Typography } from "@mui/material";
import { getMeetingDisplayStatus } from "../../utils/meetingStatus";

// Colour-coded status pill: Confirmed | Declined | Rescheduled | Pending |
// Finished. Derives its status from the meeting + current user.
const MeetingStatusBadge = ({ meeting, userId }) => {
  const { label, color } = getMeetingDisplayStatus(meeting, userId);
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: 1,
        py: 0.4,
        borderRadius: "6px",
        backgroundColor: `${color}1F`, // ~12% alpha
        border: `1px solid ${color}4D`, // ~30% alpha
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      <Typography sx={{ color, fontSize: 12, fontWeight: 600 }}>
        {label}
      </Typography>
    </Box>
  );
};

export default MeetingStatusBadge;
